/**
 * Copyright 2026 Salesforce, Inc.
 *
 * Licensed under the Apache License, Version 2.0 (the "License");
 * you may not use this file except in compliance with the License.
 * You may obtain a copy of the License at
 *
 *     http://www.apache.org/licenses/LICENSE-2.0
 *
 * Unless required by applicable law or agreed to in writing, software
 * distributed under the License is distributed on an "AS IS" BASIS,
 * WITHOUT WARRANTIES OR CONDITIONS OF ANY KIND, either express or implied.
 * See the License for the specific language governing permissions and
 * limitations under the License.
 */
import type { SVGProps } from 'react';

export function CloseIcon(props: SVGProps<SVGSVGElement>) {
    return (
        <svg fill="currentColor" viewBox="0 0 20 20" aria-hidden="true" {...props}>
            <path d="M10 11.1667L5.91667 15.25C5.76389 15.4028 5.56944 15.4792 5.33333 15.4792C5.09722 15.4792 4.90278 15.4028 4.75 15.25C4.59722 15.0972 4.52083 14.9028 4.52083 14.6667C4.52083 14.4306 4.59722 14.2361 4.75 14.0833L8.83333 10L4.75 5.91667C4.59722 5.76389 4.52083 5.56944 4.52083 5.33333C4.52083 5.09722 4.59722 4.90278 4.75 4.75C4.90278 4.59722 5.09722 4.52083 5.33333 4.52083C5.56944 4.52083 5.76389 4.59722 5.91667 4.75L10 8.83333L14.0833 4.75C14.2361 4.59722 14.4306 4.52083 14.6667 4.52083C14.9028 4.52083 15.0972 4.59722 15.25 4.75C15.4028 4.90278 15.4792 5.09722 15.4792 5.33333C15.4792 5.56944 15.4028 5.76389 15.25 5.91667L11.1667 10L15.25 14.0833C15.4028 14.2361 15.4792 14.4306 15.4792 14.6667C15.4792 14.9028 15.4028 15.0972 15.25 15.25C15.0972 15.4028 14.9028 15.4792 14.6667 15.4792C14.4306 15.4792 14.2361 15.4028 14.0833 15.25L10 11.1667Z" />
        </svg>
    );
}
